var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0a20 20 0 100 40 20 20 0 000-40zm5.068 18.105l-.331 2.787a.527.527 0 01-.526.468h-2.895v8.264a.374.374 0 01-.369.376H18a.374.374 0 01-.368-.379l.015-8.26h-2.192a.526.526 0 01-.526-.527V18.05a.526.526 0 01.526-.526h2.177v-2.7c0-3.124 1.86-4.824 4.578-4.824h2.23a.526.526 0 01.526.526v2.345a.526.526 0 01-.527.526h-1.365c-1.48.024-1.758.732-1.758 1.79v2.329h3.242a.527.527 0 01.51.59z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
export default SvgFacebook;